export enum RuleInputSchemaTypeEnum {
  Ecomm = 0,
  KittFinco = 1,
  Contract = 2,
  EcomFinco = 3,
}
